import { RefObject, useEffect } from 'react';
import { InputArea } from '@wix/design-system';

// handle textarea auto-height
export const useAutoHeight = (ref: RefObject<InputArea>, value: string) => {
  useEffect(() => {
    if (ref.current) {
      const textarea = (
        ref.current as InputArea & { textArea: HTMLTextAreaElement }
      ).textArea;
      textarea.style.cssText = 'height:auto; padding:0';
      textarea.style.cssText = 'height:' + textarea.scrollHeight + 'px';
    }
  }, [value]);
};
